import axios from 'axios';
import _ from 'lodash';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

import {typesPwrreset} from '../svtypes/pwrreset'


const headers = {'Content-Type': 'application/json'}



export function addPwrresetNow(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For createOrModifyPwrresetNow from Microservices DB swith sae key :' + rqValues)
    console.log(rqValues)
    if(rqValues && rqValues.login &&  (rqValues.addressNew.login.length > 0)){
        rqValues.addressNew.login =  rqValues.addressNew.email
    }else if(rqValues && rqValues.addressNew &&  (rqValues.addressNew.email.length > 0)){
        rqValues.addressNew.login =  rqValues.addressNew.email
    }
    let custReservationListPostRq = {
        "docId":["mm@yahoo.com"],
        "hsetname":"HotelInvDB"
    }
    const {email } = rqValues.addressNew
    if(email && (email.length > 4)){
        custReservationListPostRq.docId = []
        custReservationListPostRq.docId.push("" +email)
    }

    return dispatch => {
        dispatch(svcreateOrModifyPwrresetBegin())
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/ModifyPwrrNow`
        //this will create only 
        axios.post(url, custReservationListPostRq, {headers:headers})
        .then(
            r => {
                let comData = {
                    "my_data_pwrreset_confirmation" : {

                        "status":"OK",
                        "reguserId":"UU12345",
                        "saveDate":"Jan 3027"
                    }
                }
                if(r.data){
                   
                   
                    comData.my_data_pwrreset_confirmation = r.data
                    

                   
                    dispatch(getCreateOrModifyPwrresetSuccess(comData))
                }
                else {
                    comData.my_data_pwrreset_confirmation.status = "FAILED"
                    comData.my_data_pwrreset_confirmation.reguserId = "XXX"
                    comData.my_data_pwrreset_confirmation.saveDate = "Jan 3027"

                    dispatch(getCreateOrModifyPwrresetSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getCreateOrModifyPwrresetError(e))
        )
    }

}


export const svcreateOrModifyPwrresetBegin = () => dispatch => {
    dispatch({
        type:typesPwrreset.GET_PWRRESET_BEGIN
        
    })
}


export const getCreateOrModifyPwrresetError = (e) =>dispatch => {
    dispatch({
        type:typesPwrreset.GET_PWRRESET_ERROR,
        error:e
    })
}


export const getCreateOrModifyPwrresetSuccess = (data) => dispatch => {
    dispatch({
        type: typesPwrreset.GET_PWRRESET_SUCCESS,
        payload: data
    })
}